export const EXPERIENCES = [
  {
    id: "tutor",
    name: "EXQURA Tutor",
    tagline: "Learn from the best on the fairway",
    description:
      "Tee off alongside a certified PGA golf professional who will guide your swing, strategy, and mindset throughout 18 holes. Perfect for golfers of all levels looking to elevate their game with personalised coaching on a world-class course.",
    badge: null,
    badgeColor: null,
    duration: "Full Day (8h)",
    players: "1–4 Players",
    maxPlayers: 4,
    price: 280,
    rating: 4.9,
    reviews: 124,
    location: "Southlinks Golf & Country Club, Batam",
    image: "https://images.unsplash.com/photo-1587174486073-ae5e5cff23aa?w=1200&q=80",
    highlights: [
      "1:1 session with a certified PGA professional",
      "Personalised swing analysis with video review",
      "18 holes on a world-class Batam course",
      "Clubhouse lunch included",
      "Equipment hire available on request",
    ],
    schedule: [
      { time: "8:00 AM", title: "Meet & Greet", desc: "Meet your PGA pro at the clubhouse for a warm-up briefing and course overview." },
      { time: "9:00 AM", title: "Round Begins", desc: "18 holes with live coaching on every shot — swing mechanics, course management, and mindset." },
      { time: "1:00 PM", title: "Clubhouse Lunch", desc: "Relax over lunch while reviewing video analysis recorded during your round." },
      { time: "2:30 PM", title: "Debrief Session", desc: "Your pro shares a personalised improvement plan with drills and training tips." },
      { time: "4:00 PM", title: "Wrap Up", desc: "Transfer back to your hotel or continue exploring Batam at your own pace." },
    ],
    includes: [
      "Green fees (18 holes)",
      "PGA-certified coaching all day",
      "Video swing analysis",
      "Clubhouse lunch",
      "Return transfer to course",
    ],
  },
  {
    id: "therapy",
    name: "EXQURA Therapy",
    tagline: "Golf meets wellness — the perfect escape",
    description:
      "Start your morning with a relaxed round of golf on a scenic course, then unwind with a curated spa and wellness package at a luxury resort. The ideal balance of sport and serenity.",
    badge: "RELAX",
    badgeColor: "bg-teal-600",
    duration: "Full Day (9h)",
    players: "2–6 Players",
    maxPlayers: 6,
    price: 320,
    rating: 4.8,
    reviews: 98,
    location: "Tering Bay Golf Club & Montigo Resorts, Batam",
    image: "https://images.unsplash.com/photo-1535131749006-b7f58c99034b?w=1200&q=80",
    highlights: [
      "Morning 18-hole round on a scenic Batam course",
      "90-minute luxury spa treatment",
      "Healthy gourmet lunch at the resort",
      "Full resort day-pass (pool, gym, facilities)",
      "Sunset cocktail on the terrace",
    ],
    schedule: [
      { time: "7:30 AM", title: "Golf Round", desc: "Tee off on a beautifully maintained Batam course as the morning mist lifts." },
      { time: "11:30 AM", title: "Resort Arrival", desc: "Transfer to Montigo Resorts Nongsa for a warm welcome and refreshing welcome drink." },
      { time: "12:00 PM", title: "Gourmet Lunch", desc: "Healthy, chef-curated lunch at the resort's beachfront restaurant." },
      { time: "1:30 PM", title: "Spa Treatment", desc: "90-minute signature spa session — choose from massage, body scrub, or facial." },
      { time: "3:30 PM", title: "Resort Leisure", desc: "Free time at the pool, gym, or beach — unwind at your own pace." },
      { time: "5:30 PM", title: "Sunset Cocktail", desc: "Toast the day with a cocktail on the terrace as the sun sets over the Strait." },
      { time: "6:30 PM", title: "Departure", desc: "Transfer back to your hotel or the ferry terminal." },
    ],
    includes: [
      "Green fees (18 holes)",
      "Return transfers",
      "90-min luxury spa treatment",
      "Gourmet healthy lunch",
      "Resort day-pass",
      "Welcome & sunset drink",
    ],
  },
  {
    id: "tonic",
    name: "EXQURA Tonic",
    tagline: "Drive by day, celebrate by night",
    description:
      "Experience the thrill of golf by day and the excitement of Batam's vibrant nightlife by night. The ultimate golfer's social experience — from the tee box to the dance floor.",
    badge: "VIP",
    badgeColor: "bg-purple-600",
    duration: "Day & Night (12h)",
    players: "2–8 Players",
    maxPlayers: 8,
    price: 350,
    rating: 4.7,
    reviews: 76,
    location: "Palm Spring Golf, Batam + VIP Venues",
    image: "https://images.unsplash.com/photo-1511632765486-a01980e01a18?w=1200&q=80",
    highlights: [
      "Afternoon 18-hole round at Palm Spring Golf",
      "VIP table reservation at a premier restaurant",
      "Exclusive nightclub access with welcome bottles",
      "Private group transfers throughout the day",
      "Personalised EXQURA event host",
    ],
    schedule: [
      { time: "2:00 PM", title: "Afternoon Round", desc: "Tee off for 18 relaxed holes at Palm Spring Golf Club — competitive but fun." },
      { time: "6:00 PM", title: "Shower & Change", desc: "Freshen up at your hotel. Your EXQURA host picks you up at 7:30 PM." },
      { time: "7:30 PM", title: "VIP Dinner", desc: "Private table at one of Batam's best restaurants — curated 4-course menu." },
      { time: "9:30 PM", title: "Nightclub Access", desc: "Skip the queue with VIP entry. Welcome bottles and exclusive booth seating await." },
      { time: "1:00 AM", title: "Private Transfer", desc: "Your driver brings the group safely back to your hotel." },
    ],
    includes: [
      "Green fees (18 holes)",
      "All group transfers",
      "4-course VIP dinner",
      "Nightclub entry & welcome bottles",
      "Personal EXQURA host",
    ],
  },
];
